export const getContacts = (state) => state.contacts
export const getContactSuppliers = (state) => state.contactSuppliers
export const getScrollContacts= (state) => state.contactScroll
export const getScrollContactsCount = (state) => state.contactScrollCount
